import axios, { AxiosRequestConfig } from 'axios';

const instance = axios.create({
    baseURL: '/api',
});

export const fetcher = async (config: AxiosRequestConfig) => {
    const token = localStorage.getItem('auwx');
    const headers = {
        Authorization: `Bearer ${token}`,
        ...config.headers,
    };
    const { data } = await instance({ ...config, headers });

    return data;
};
